import * as Html from "../../util/Html.ts";

function init(theNode){
  
  var 
    //FIXME set a selector way to gey the stuff
    input = theNode.prev();
  
  input.on('keydown',function(event){
    let 
      down = event.keyCode===40,
      up = event.keyCode===38;
    if(event.keyCode===9 && theNode.find('div').length){
      event.preventDefault();
      if(event.shiftKey){
        up=true
      }else{
        down=true;
      }
    }
    if(down){
      var done = theNode.find('.selected').removeClass('selected').next().addClass('selected')
      if(!done.length){
        theNode.find('>*').first().addClass('selected')
      }
      return;
    }
    if(up){
      var done = theNode.find('.selected').removeClass('selected').prev().addClass('selected')
      if(!done.length){
        theNode.find('>*').last().addClass('selected')
      }
      return;
    }
    if(event.keyCode===10||event.keyCode===13){
      var selected = theNode.find('.selected').first();
      if(selected.length){
        selected.trigger('click');
      
      //}else if(this.value === theNode.find('span').first().text()){
      //  pick(theNode.find('div').first());
      }
    }  
    
  });  
}
Html.registerWidget('widget/form/selectableByKeyBoard',{init:init})

export{init}